import React from 'react';
import PropTypes from 'prop-types';
import DevisResume from './DevisResume';
import devisBo from '../../data/devis/Devis';
import ClientResume from './ClientResume';
import ParentEditorComponent from '../../custom/ParentEditorComponent';
import DevisService from '../../../services/devis/DevisService';
import ClientService from '../../../services/clients/ClientService';
import CategorieProduitService from '../../../services/categorieProduit/CategorieProduitService';
import menuData from '../MenuDatas';

import '../EditionPage.css';
import DevisParamsContent from './DevisParamsContent';
import TabCustom from '../../custom/tabs/TabCustom';
import tabCustomBo from '../../custom/tabs/TabCustomData';
import DevisContent from './content/DevisContent';

class Devis extends ParentEditorComponent {
    clientService = new ClientService();
    onglets = [];

    constructor(props) {
        super(props, "devis", DevisService, devisBo);
        var data = this.loadData();
        this.state = {
            data: data,
        };
        this.initOnglets();
    }

    createDevis() {
        var url = window.location.pathname;
        var clientNum = null;
        if (url.indexOf("/client/") > -1) {
            clientNum = url.replace(menuData.devisEdit.path + "/client/", "");
            if (this.clientService.getByNumero(clientNum) == null) {
                clientNum = null;
            }
        }
        console.log(clientNum);
        return clientNum;
    }

    loadData() {
        var clientNum = this.createDevis();
        //en mode dev --> super.loadData() � d�placer dans le if en dessous pour ne pas init en mode update
        var data = super.loadData();
        if (super.createdMode) {
            var catProdService = new CategorieProduitService();
            data.params = Object.assign({}, data.params, catProdService.getAllDefaultCodeValue());
            data.resume.dateCreation = new Date();
        }
        return data;
    }

    renderInfosTab() {
        var styleSeparator = {};
        if (super.size.width < 1160) {
            styleSeparator = { 'display': 'none' };
        }
        return (
            <div>
                <div className="separator" style={styleSeparator} />
                <div className="editDiv">
                    <DevisResume devisResume={this.state.data.resume} />
                </div>
                <div className="separator" style={styleSeparator} />
                <div className="editDiv">
                    <ClientResume clientResume={this.state.data.client} />
                </div>
                <DevisParamsContent params={this.state.data.params} />
            </div>);
    }

    initOnglets() {
        var ongletInfos = Object.assign({}, tabCustomBo);
        ongletInfos.label = "Informations";
        ongletInfos.content = this.renderInfosTab();
        var ongletContent = Object.assign({}, tabCustomBo);
        ongletContent.label = "Contenu";
        ongletContent.content = (<DevisContent datas={this.state.data} />);

        this.onglets.push(ongletInfos);
        this.onglets.push(ongletContent);
    }

    handleSubmit = (event) => {
        event.preventDefault();
        console.log("Enregistrement OK");
        console.log(this.state.data);
        return true;
    }

    render() {
        return (<div id='devis'>
            <form action="/" method="POST" onSubmit={this.handleSubmit}>
                <TabCustom onglets={this.onglets} />
            </form>
        </div>);
    }
}

export default Devis


// WEBPACK FOOTER //
// ./src/components/content/devis/Devis.js